import confetti from 'canvas-confetti';

const COLORS = ['#E11D2A', '#D8374A', '#FFFFFF', '#7A0C13'];

export const celebrate = () => {
  const end = Date.now() + 700;
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 60, origin: { x: 0 }, colors: COLORS });
    confetti({ particleCount: 4, angle: 120, spread: 60, origin: { x: 1 }, colors: COLORS });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
  confetti({ particleCount: 120, spread: 80, startVelocity: 45, origin: { y: 0.6 }, colors: COLORS });
};
